import React from 'react';
import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div
      className="relative min-h-screen text-white flex flex-col p-5 overflow-hidden bg-rsplay-navy"
      style={{
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Black vignette + gold radial glow for luxury depth */}
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-rsplay-navy/90 via-black/85 to-black" />
      <div className="absolute inset-0 z-0 bg-casino-radial" />

      {/* Logo */}
      <img
        src="/betexLogo.png"
        alt="Betex"
        className="w-40 relative z-10 drop-shadow-[0_0_18px_rgba(234,173,7,0.35)]"
      />

      {/* Centered Section */}
      <div className="flex-grow flex items-center justify-center relative z-10">
        <div className="relative max-w-[440px] w-full mx-auto flex-center flex-col">
          <Outlet />
        </div>
      </div>

      {/* Footer */}
      <p className="relative z-10 text-center text-xs text-white/40 pb-1">
        &copy; {new Date().getFullYear()} All rights reserved.
      </p>
    </div>
  );
}
